import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { SystemUser } from "../../types/User";

export const getMySalesOwner = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["salesOwner"],
    queryFn: (): Promise<SystemUser> => {
      return fetchWithAuth<SystemUser>("getMySalesOwner");
    },
    enabled: isQueryEnabled(options),
  });
};
